<template>
  <div>
    <section class="section">
      <div class="container">
        <h1 class="heading is-size-4">Terms of Service</h1>
        <br />
        <h2 class="title is-size-5">General</h2>
        <p>
          SpeakyReads website and related services (together with the Website,
          the “Service”) are operated by SpeakyReads (“SpeakyReads”, “provider”,
          “us”, or “we”). Access and use of the Service is subject to the
          following Terms and Conditions of Service (“Terms and Conditions”). By
          accessing or using any part of the Service, you (“you” or “User”)
          represent that you have read, understood, and agree to be bound by
          these Terms and Conditions including any future modifications.
          SpeakyReads may amend, update or change these Terms and Conditions. If
          we do this, we will indicate at the bottom of the Terms and Conditions
          the date these terms were last revised. Any revisions to these Terms
          and Conditions will become effective the earlier of (i) the end of a
          7-day period after such changes or (ii) the first time you access or
          use the Service after such changes. If you do not agree to abide by
          these Terms and Conditions, you are not authorized to use, access or
          participate in the Service.
        </p>
        <br />
        <h2 class="title is-size-5">Description of Website and Service</h2>
        <p>
          The Service allows users to access and use a variety of educational
          resources, including learning and practicing a language. Some features
          and content are available to the user free of charge. Non-free
          services are clearly identified as such and may be used against
          payment of the respective charges or prices. SpeakyReads may, in its
          sole discretion and at any time, update, change, suspend, make
          improvements to or discontinue any aspect of the Service, temporarily
          or permanently.
        </p>
        <br />
        <p>
          These Terms and Conditions and the services regulated by them are
          exclusively intended for Users who act as consumers. A consumer is any
          natural person who enters into a legal transaction for purposes which
          are predominantly neither commercial nor self-employment.
        </p>
        <br />
        <h2 class="title is-size-5">Registration</h2>
        <p>
          You can create a basic user account at SpeakyReads for free. For this
          you must use one of the supported third party login providers
          (currently Google or Facebook). During the registration process, we
          obtain your email and names from your account with the third party
          login provider. Each user may register only once. The only
          prerequisite for opening a user account is that the User must be over
          the age of 13.
        </p>
        <br />
        <h2 class="title is-size-5">Inappropriate Use</h2>
        <p>
          You will not upload, display or otherwise provide on or through the
          Service any content that: (i) is libelous, defamatory, abusive,
          threatening, harassing, hateful, offensive or otherwise violates any
          law or infringes upon the right of any third party (including
          copyright, trademark, privacy, publicity or other personal or
          proprietary rights); or (ii) in SpeakyReads’ sole judgment, is
          objectionable or which restricts or inhibits any other person from
          using the Service or which may expose SpeakyReads or its users to any
          harm or liability of any kind.
        </p>
        <br />
        <p>
          SpeakyReads may only be used in accordance with these Terms and
          Conditions. In particular, Users are not authorized to: (i) Reverse
          engineer, decompile, disassemble, modify, or create derivative works
          based on the Service or parts of the Service (ii) Circumvent
          protective measures that the provider or its licensors use to protect
          content that is accessible via SpeakyReads (iii) To copy, store, edit
          derivative works made by SpeakyReads, to develop derivative works
          based on them, or to modify them in any way; (iv) To lease their own
          user account or to grant sub-licenses; (v) Sharing one’s own user
          account with other persons and / or granting others access to the paid
          services of SpeakyReads (so-called “shared account”); (vi) Use
          SpeakyReads in any other improper manner that violates these Terms and
          Conditions. In these cases, as well as in all other cases of improper
          use, the User agrees to indemnify the provider. In any case, the
          provider reserves the right to block user accounts without notice as
          soon as there is an indication of improper or abusive use and the
          provider has a legitimate interest in blocking.
        </p>
        <br />
        <h2 class="title is-size-5">Indemnification</h2>
        <p>
          You agree to defend, indemnify and hold harmless SpeakyReads and its
          directors, officers, employees, contractors, agents, suppliers,
          licensors, successors and assigns, from and against any and all
          losses, claims, causes of action, obligations, liabilities and damages
          whatsoever, including attorneys' fees, arising out of or relating to
          your access or use of the Service, any false representation made to us
          (as part of these Terms and Conditions or otherwise), your breach of
          any of these Terms and Conditions, or any claim that any translation
          we provide to you is inaccurate, inappropriate or defective in any way
          whatsoever.
        </p>
        <br />
        <h2 class="title is-size-5">Payment Processors</h2>
        <p>
          All financial transactions made in connection with the Service will be
          processed by a third party in accordance with their respective terms
          of use, privacy policy, and/or any applicable payment terms and
          conditions. We encourage you to learn about the practices of such
          third parties. In no event will SpeakyReads be responsible for the
          actions or inactions of any third party payment processor, including,
          but not limited to, system downtime or payment service outages.
        </p>
        <br />
        <p>
          Use of the Services may necessitate usage of services from third
          parties not related to Us, including, without limitation, Payment
          Gateway partner (“Payment Gateway Partner”), Stripe (whose terms are
          located at
          <a
            href="https://stripe.com/gb/connect-account/legal"
            target="_blank"
            rel="noopener noreferrer"
          ></a>
          and
          <a
            href="https://stripe.com/gb/legal"
            target="_blank"
            rel="noopener noreferrer"
          ></a>
          - please note that SpeakyReads may from time to time change the
          Payment Gateway Partner at its sole discretion). You agree that the
          terms of use for Stripe (or the Payment Gateway Partner from time to
          time) including such terms as amended from time to time in the Payment
          Gateway Partner’s sole discretion, are incorporated into these Terms
          and Conditions, and you will be subject to any terms applicable to
          such third party services (“Third Party Terms”) .
        </p>
        <br />
        <p>
          It is your responsibility to ensure your compliance at all times with
          such Third Party Terms. If you do not agree with such Third Party
          Terms, you must immediately cease and forever desist from accessing
          the Service.
        </p>
        <br />
        <p>
          Together with these Terms and Conditions, such Third Party Terms will
          govern your use of the Service or any other services made available by
          us to you.
        </p>
        <br />
        <p>
          You agree to indemnify Us and our employees, directors, contractors,
          agents, and related parties (“Those Indemnified”) and keep Those
          Indemnified from any direct, indirect or consequential loss, cost,
          expense, damage or liability arising as a result of, or as a natural
          consequence of, or in connection with or in relation to any act or
          omission, whether negligent or otherwise, which constitutes a breach
          of any Third Party Terms applicable to your use of the Service, and
          whether such loss, cost, expense, damage or liability is founded in
          contract, tort or any other legal theory, and whether such loss, cost,
          expense, damage or liability is actual or contingent, present or
          future, quantified or unquantified.
        </p>
        <br />
        <h2 class="title is-size-5">Refund Policy</h2>
        <p>
          In the event that SpeakyReads suspends or terminates your use of the
          Service or these Terms and Conditions or you close your account
          voluntarily, you understand and agree that you will receive no refund
          or exchange of any kind, including for any data associated with your
          use of the Service, or for anything else.
        </p>
        <br />
        <h2 class="title is-size-5">Third-Party Links, Sites, and Services</h2>
        <p>
          The Service may contain links to third-party websites, advertisers,
          services, special offers, or other events or activities that are not
          owned or controlled by SpeakyReads. We do not endorse or assume any
          responsibility for any such third-party sites, information, materials,
          products, or services. If you access any third party website, service,
          or content from SpeakyReads, you understand that these Terms and
          Conditions and our Privacy Policy do not apply to your use of such
          sites. You expressly acknowledge and agree that SpeakyReads shall not
          be responsible or liable, directly or indirectly, for any damage or
          loss arising from your use of any third-party website, service, or
          content.
        </p>
        <br />
        <h2 class="title is-size-5">
          NO REPRESENTATIONS OR WARRANTIES BY SPEAKYREADS
        </h2>
        <p>
          THE SERVICE, INCLUDING ALL IMAGES, AUDIO FILES AND OTHER CONTENT
          THEREIN, AND ANY OTHER INFORMATION, PROPERTY AND RIGHTS GRANTED OR
          PROVIDED TO YOU BY SPEAKYREADS ARE PROVIDED TO YOU ON AN “AS IS”
          BASIS. SPEAKYREADS AND ITS SUPPLIERS MAKE NO REPRESENTATIONS OR
          WARRANTIES OF ANY KIND WITH RESPECT TO THE SERVICE, EITHER EXPRESS OR
          IMPLIED, AND ALL SUCH REPRESENTATIONS AND WARRANTIES, INCLUDING
          WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE OR
          NON-INFRINGEMENT, ARE EXPRESSLY DISCLAIMED. WITHOUT LIMITING THE
          GENERALITY OF THE FOREGOING, SPEAKYREADS DOES NOT MAKE ANY
          REPRESENTATION OR WARRANTY OF ANY KIND RELATING TO ACCURACY, SERVICE
          AVAILABILITY, COMPLETENESS, INFORMATIONAL CONTENT, ERROR-FREE
          OPERATION, RESULTS TO BE OBTAINED FROM USE, OR NON-INFRINGEMENT.
          ACCESS AND USE OF THE SERVICE MAY BE UNAVAILABLE DURING PERIODS OF
          PEAK DEMAND, SYSTEM UPGRADES, MALFUNCTIONS OR SCHEDULED OR UNSCHEDULED
          MAINTENANCE OR FOR OTHER REASONS. SOME JURISDICTIONS DO NOT ALLOW THE
          EXCLUSION OF IMPLIED WARRANTIES, SO THE ABOVE EXCLUSION MAY NOT APPLY
          TO YOU.
        </p>
        <br />
        <h2 class="title is-size-5">
          LIMITATION ON TYPES OF DAMAGES/LIMITATION OF LIABILITY
        </h2>
        <p>
          IN NO EVENT WILL SPEAKYREADS BE LIABLE TO YOU OR ANY THIRD PARTY
          CLAIMING THROUGH YOU (WHETHER BASED IN CONTRACT, TORT, STRICT
          LIABILITY OR OTHER THEORY) FOR INDIRECT, INCIDENTAL, SPECIAL,
          CONSEQUENTIAL OR EXEMPLARY DAMAGES ARISING OUT OF OR RELATING TO THE
          ACCESS OR USE OF, OR THE INABILITY TO ACCESS OR USE, THE SERVICE OR
          ANY PORTION THEREOF, INCLUDING BUT NOT LIMITED TO THE LOSS OF USE OF
          THE SERVICE, INACCURATE RESULTS, LOSS OF PROFITS, BUSINESS
          INTERRUPTION, OR DAMAGES STEMMING FROM LOSS OR CORRUPTION OF DATA OR
          DATA BEING RENDERED INACCURATE, THE COST OF RECOVERING ANY DATA, THE
          COST OF SUBSTITUTE SERVICES OR CLAIMS BY THIRD PARTIES FOR ANY DAMAGE
          TO COMPUTERS, SOFTWARE, MODEMS, TELEPHONES OR OTHER PROPERTY, EVEN IF
          SPEAKYREADS HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.
          SPEAKYREADS’ LIABILITY TO YOU OR ANY THIRD PARTY CLAIMING THROUGH YOU
          FOR ANY CAUSE WHATSOEVER, AND REGARDLESS OF THE FORM OF THE ACTION, IS
          LIMITED TO THE AMOUNT PAID, IF ANY, BY YOU TO SPEAKYREADS FOR THE
          SERVICE IN THE 12 MONTHS PRIOR TO THE INITIAL ACTION GIVING RISE TO
          LIABILITY. THIS IS AN AGGREGATE LIMIT. THE EXISTENCE OF MORE THAN ONE
          CLAIM HEREUNDER WILL NOT INCREASE THIS LIMIT.
        </p>
        <br />
        <h2 class="title is-size-5">Website Accessibility</h2>
        <p>
          SpeakyReads uses the current and commonly used technologies for its
          services. In order to fully use SpeakyReads, the User must also use
          these technologies (e.g. current browser technologies) or enable their
          use on their computer or mobile device (e.g. activation of Javascript,
          cookies, pop-ups). When using older or not commonly used technologies,
          it is possible that the User can only use SpeakyReads to a limited
          extent.
        </p>
        <br />
        <p>
          The internet services required for the use of SpeakyReads and the
          necessary equipment are the sole responsibility of the User with
          regard to the costs incurred, the availability and the security of the
          data connection.
        </p>
        <br />
        <p>
          SpeakyReads expressly does not guarantee that the services offered are
          suitable for the specific goals pursued by the individual user.
        </p>
        <br />
        <h2 class="title is-size-5">Termination</h2>
        <p>
          SpeakyReads may terminate your access and use of the Service
          immediately at any time, for any reason, and at such time you will
          have no further right to use the Service. You may terminate your
          SpeakyReads account at any time by following the instructions
          available through the Service. The provisions of these Terms and
          Conditions relating to the protection and enforcement of SpeakyReads’
          proprietary rights, your representations and warranties, disclaimer of
          representations and warranties, release and indemnities, limitations
          of liability and types of damages, ownership of data and information,
          governing law and venue, and miscellaneous provisions shall survive
          any such termination.
        </p>
        <br />
        <h2 class="title is-size-5">Proprietary Rights in Service Content</h2>
        <p>
          All content available through the Service, including designs, text,
          graphics, images, information, software, audio and other files, and
          their selection and arrangement (the "Service Content"), are the
          proprietary property of SpeakyReads or its licensors. No Service
          Content may be modified, copied, distributed, framed, reproduced,
          republished, downloaded, scraped, displayed, posted, transmitted, or
          sold in any form or by any means, in whole or in part, other than as
          expressly permitted in these Terms and Conditions. You may not use any
          data mining, robots, scraping or similar data gathering or extraction
          methods to obtain Service Content.
        </p>
        <br />
        <h2 class="title is-size-5">Privacy</h2>
        <p>
          Use of the Service is also governed by our Privacy Policy, a copy of
          which is located <router-link to="/privacy-policy">here</router-link>.
          By using the Service, you consent to the terms of the Privacy Policy.
        </p>
        <br />
        <h2 class="title is-size-5">
          Notice for Claims of Copyright Violations and Agent for Notice
        </h2>
        <p>
          If you are a copyright owner and have a good faith belief that any
          material available through the Service infringes upon your copyrights,
          you may submit a copyright infringement notification to SpeakyReads
          pursuant to the Digital Millennium Copyright Act by providing us with
          the following information in writing: (i) an electronic or physical
          signature of the copyright owner or the person authorized to act on
          behalf of the owner of the copyright interest; (ii) a description of
          the copyrighted work that you claim has been infringed; (iii) a
          description of where the material that you claim is infringing is
          located on the Service, with enough detail that we may find it on the
          Service; (iv) your address, telephone number, and email address; (v) a
          statement by you that you have a good faith belief that the disputed
          use is not authorized by the copyright owner, its agent, or the law;
          and (vi) a statement by you, made under penalty of perjury, that the
          above information in your notice is accurate and that you are the
          copyright owner or are authorized to act on the copyright owner's
          behalf. You can reach us by email at alex@speakyreads.com
        </p>
        <br />
        <h2 class="title is-size-5">Miscellaneous</h2>
        <p>
          These Terms and Conditions constitute the entire agreement between
          SpeakyReads and you concerning the subject matter hereof. In the event
          that any of the Terms and Conditions are held by a court or other
          tribunal of competent jurisdiction to be unenforceable, such
          provisions shall be limited or eliminated to the minimum extent
          necessary so that these Terms and Conditions shall otherwise remain in
          full force and effect. A waiver by SpeakyReads or you of any provision
          of these Terms and Conditions or any breach thereof, in any one
          instance, will not waive such term or condition or any subsequent
          breach thereof. SpeakyReads may assign its rights or obligations under
          these Terms and Conditions without condition. These Terms and
          Conditions will be binding upon and will enure to the benefit of
          SpeakyReads and you, and SpeakyReads’ and your respective successors
          and permitted assigns.
        </p>
        <br />
        <h2 class="title is-size-5">Governing law</h2>
        <p>
          These terms and conditions are governed by and construed in accordance
          with the laws of England and Wales. Any dispute you have which relates
          to these terms and conditions, or your use of SpeakyReads (whether it
          be contractual or non-contractual), will be subject to the exclusive
          jurisdiction of the courts of England and Wales.
        </p>
        <br />
        <p>Last revision: <b>08/02/2020</b></p>
      </div>
    </section>
  </div>
</template>

<script>
export default {};
</script>
